"use client";

import React, { useEffect, useState } from "react";
import styles from "./blog-post.module.scss";
import { PostOrPage } from "@tryghost/content-api";
import Image from "next/image";
import { useParams } from "next/navigation";
import dayjs from "dayjs";
import BlogLoader from "@/components/blocks/blog-post/blog-loader";
import {
  FullBlogPost,
  getFullBlogPost,
} from "@/services/api/cms/get-full-blog-post";

const BlogPost = () => {
  const [loading, setLoading] = useState(false);
  const [post, setPost] = useState<FullBlogPost>();
  const { slug } = useParams<{ slug: string }>()!;

  useEffect(() => {
    (async () => {
      setLoading(true);
      try {
        const post = await getFullBlogPost(slug);
        setPost(post);
      } catch (error) {
        console.error("Error fetching post: ", error);
      } finally {
        setLoading(false);
      }
    })();
  }, [slug]);

  if (loading) {
    return <BlogLoader />;
  } else {
    return (
      <div className={styles.blogContainer}>
        <div className={styles.headerSection}>
          {post?.feature_image && (
            <Image
              src={(post?.feature_image as string) || ""}
              alt={post?.feature_image_alt as string}
              width={400}
              height={400}
              className={styles.image}
            />
          )}
          <div className={styles.contentContainer}>
            <div className={styles.header}>{post?.title}</div>
            <div className={styles.date}>
              <span>Posted on:</span>{" "}
              {dayjs(post?.published_at as string).format("MMM D YYYY")}
            </div>
            <div className={styles.excerpt}>{post?.excerpt}</div>
          </div>
        </div>
        <div
          dangerouslySetInnerHTML={{ __html: post?.html as string }}
          className={styles.blogContent}
        />
      </div>
    );
  }
};

export default BlogPost;
